module.exports = __webpack_public_path__ + "img/google.1d7a9de0.png";